import React, { useEffect } from "react";
import { FranjaFija } from "../componentes/franjaFija";
import { NavbarGeneral } from "../componentes/navbarGeneral";
import { CustomFooter } from "../componentes/footer";
import { BotonWhatsappFlotante } from "../componentes/botonWhatsappFlotante";
import { PreguntasFrecuentes, ANIMACIONES_FAQ } from "../componentes/preguntasFrecuentes";
import { useAnimacionesAlScroll } from "../useAnimacionesAlScroll";
import "../promocion.css";

const WHATSAPP =
  "https://wa.me/5492396416909?text=Hola%2C%20quer%C3%ADa%20obtener%20informaci%C3%B3n%20acerca%20de%20Mundo%20Piloto";

// Las imágenes de fondo se pasan como variables CSS: las rutas de public/ no se pueden poner directo en el CSS
const IMAGENES_FONDO = {
  "--promo-hero": "url('/img/promo/fondo_nurburgring_hero.jpg')",
  "--promo-acceso": "url('/img/promo/frame-acceso-online-acomodado.jpg')",
  "--promo-resultados": "url('/img/promo/frame-resultado-calendario-acomodado.jpg')",
  "--promo-casoreal": "url('/img/promo/frame-caso-real.jpg')",
  "--promo-piloto": "url('/img/promo/piloto-festejando.jpg')",
};

const DISCIPLINAS = [
  { nombre: "Rally", imagen: "rally.jpg" },
  { nombre: "Karting", imagen: "karting.jpg" },
  { nombre: "Automovilismo", imagen: "turismo.jpg" },
  { nombre: "Motocross", imagen: "motocross.jpg" },
  { nombre: "Motociclismo", imagen: "motogp.jpg" },
];

const TITULO = "Mundo Piloto | Software de gestión para asociaciones de automovilismo";
const DESCRIPCION =
  "Plataforma online para asociaciones de automovilismo, karting, rally, motocross y motociclismo: campeonatos, carreras, resultados, pilotos y calendarios en un solo lugar.";

// Título y descripción de esta ruta para cuando se llega navegando dentro de la app (si se entra directo, ya vienen
// en promocion.html, que genera scripts/prerender.js junto con los datos estructurados)
const useMetadatosPromocion = () => {
  useEffect(() => {
    const tituloAnterior = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const descripcionAnterior = meta?.getAttribute("content");
    document.title = TITULO;
    meta?.setAttribute("content", DESCRIPCION);

    return () => {
      document.title = tituloAnterior;
      if (descripcionAnterior != null) meta.setAttribute("content", descripcionAnterior);
    };
  }, []);
};

// Colores de los costados de cada sección (el contenido se centra a 1280 px; son los colores de los bordes de las imágenes)
const BORDES = {
  hero: [
    "linear-gradient(180deg, #101F2B 0%, #12222B 20%, #152626 40%, #19282A 60%, #1B2928 80%, #162531 100%)",
    "linear-gradient(180deg, #192A38 0%, #16252B 20%, #192B2A 40%, #222425 60%, #1D2B28 80%, #1E2D27 100%)",
  ],
  acceso: [
    "linear-gradient(180deg, #8B644A 0%, #8B7A70 20%, #9B7A76 40%, #8D4439 60%, #9B2A2B 80%, #B82223 100%)",
    "linear-gradient(180deg, #8AAAAB 0%, #B2A99E 20%, #906E66 40%, #8A443D 60%, #9F2E2A 80%, #B72223 100%)",
  ],
  casoReal: [
    "linear-gradient(180deg, #100C05 0%, #0D0A05 20%, #162327 40%, #0A0A05 60%, #0F190C 80%, #080A04 100%)",
    "linear-gradient(180deg, #2B2001 0%, #342E0E 20%, #0D1802 40%, #121A09 60%, #1A1D0D 80%, #181606 100%)",
  ],
};

// Animaciones de entrada de esta página (ver useAnimacionesAlScroll)
const ANIMACIONES = [
  { selector: ".hero .barra-roja, .hero h1, .hero p, .hero .btn-whatsapp", tipo: "izq", escalonar: true },
  { selector: ".lista-caracteristicas li", tipo: "subir", escalonar: true },
  { selector: ".titulo-banner", tipo: "izq" },
  { selector: ".columnas .columna", tipo: "subir", escalonar: true },
  { selector: ".btn-demo", tipo: "zoom" },
  { selector: ".acceso-cabecera > *", tipo: "izq", escalonar: true },
  // cada panel: primero el título y la bajada, y después las barras de a una (los dos paneles entran a la par)
  { selector: ".acceso-paneles .panel:nth-child(odd) h3, .acceso-paneles .panel:nth-child(odd) p", tipo: "izq", escalonar: true },
  { selector: ".acceso-paneles .panel:nth-child(even) h3, .acceso-paneles .panel:nth-child(even) p", tipo: "der", escalonar: true },
  { selector: ".acceso-paneles .panel:nth-child(odd) li", tipo: "izq", escalonar: true, inicio: 0.3 },
  { selector: ".acceso-paneles .panel:nth-child(even) li", tipo: "der", escalonar: true, inicio: 0.3 },
  { selector: ".cta-intermedio > *", tipo: "subir", escalonar: true },
  { selector: ".resul-pilot-calend-cabecera > *", tipo: "izq", escalonar: true },
  { selector: ".resul-pilot-calend-filas .fila", tipo: "subir", escalonar: true },
  { selector: ".datos-reales li", tipo: "zoom", escalonar: true },
  ...ANIMACIONES_FAQ,
  { selector: ".contacto-contenido > *", tipo: "subir", escalonar: true },
];

// Página de promoción de Mundo Piloto (ruta /promocion)
// En monitores grandes el contenido queda fijo en 1280 px de ancho (ver FranjaFija); en tablets y celulares se adapta
export const Promocion = () => {
  useAnimacionesAlScroll(ANIMACIONES, ".promo");
  useMetadatosPromocion();

  return (
    <>
    <NavbarGeneral soloInicio />
    <div className="promo" style={IMAGENES_FONDO}>
      <main>
        <FranjaFija izq={BORDES.hero[0]} der={BORDES.hero[1]}>
        <section className="hero">
          <h1>
            <span className="barra-roja"></span>
            Gestioná tu asociación <br />
            <span className="texto-rojo">en un solo lugar</span>
          </h1>
          <p>
            La solución para asociaciones de automovilismo que buscan una gestión <br /> más simple, moderna y
            organizada
          </p>
          <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" className="btn-whatsapp">
            <img width="150" src="/img/promo/whatsapp-icon.svg" alt="WhatsApp logo" className="icono-whatsapp" />
            Solicitar información por WhatsApp
          </a>
        </section>
        </FranjaFija>
        <FranjaFija izq="#000">
        <ul className="lista-caracteristicas">
          <li>Multidisciplina</li>
          <li>Acceso online</li>
          <li>Resultados, pilotos y calendarios</li>
        </ul>
        </FranjaFija>

        <FranjaFija izq="#D9D9D9">
        <section className="multidisciplina">
          <div className="titulo-banner">
            <span className="barra-roja"></span>
            <h2>
              Una plataforma <br />
              <span className="texto-rojo-h2">para distintas competiciones</span>
            </h2>
          </div>

          <div className="columnas">
            {DISCIPLINAS.map((disciplina) => (
              <figure className="columna" key={disciplina.nombre}>
                <div className="marco">
                  <img
                    src={`/img/promo/${disciplina.imagen}`}
                    alt={disciplina.nombre}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <figcaption style={{ "--letras": disciplina.nombre.length }}>{disciplina.nombre}</figcaption>
              </figure>
            ))}
          </div>

          <a href={WHATSAPP} className="btn-demo" target="_blank" rel="noopener noreferrer">
            Agendá tu demo
          </a>
        </section>
        </FranjaFija>

        <section className="acceso">
          <FranjaFija izq="#05192A">
          <div className="acceso-cabecera">
            <span className="barra-roja"></span>
            <h2>Acceso 100% online</h2>
            <h3>Entrá desde cualquier dispositivo dondequiera que estés</h3>
          </div>
          </FranjaFija>

          <FranjaFija izq={BORDES.acceso[0]} der={BORDES.acceso[1]}>
          <div className="acceso-paneles">
            <div className="panel">
              <h3>App para pilotos</h3>
              <p>Tu calendario, resultados y posiciones en el celular</p>
              <ul>
                <li>Inscripción a carreras</li>
                <li>Tu historial guardado</li>
                <li>Resultados en vivo</li>
              </ul>
            </div>

            <div className="panel">
              <h3>Gestión de asociaciones</h3>
              <p>Administrá todo desde un solo lugar</p>
              <ul>
                <li>Campeonatos y posiciones</li>
                <li>Carreras y resultados</li>
                <li>Gestión de pilotos</li>
              </ul>
            </div>
          </div>
          </FranjaFija>
        </section>

        <FranjaFija izq="#06192A" der="#06192A">
        <section className="cta-intermedio">
          <h2>
            ¿Querés verlo <span className="texto-rojo-h2">en acción?</span>
          </h2>
          <a href={WHATSAPP} className="btn-demo" target="_blank" rel="noopener noreferrer">
            Agendá tu demo
          </a>
        </section>
        </FranjaFija>

        <FranjaFija izq="#06192A">
        <section className="resultados-pilotos-calendarios">
          <div className="resul-pilot-calend-cabecera">
            <span className="barra-roja"></span>
            <h2>Resultados, pilotos y calendarios</h2>
          </div>

          <div className="resul-pilot-calend-filas">
            <div className="fila">
              <h3>Resultados</h3>
              <h4>Siempre al día</h4>
              <p>Consultá los resultados y posiciones del campeonato</p>
            </div>

            <div className="fila">
              <h3>Pilotos</h3>
              <h4>Cada piloto registrado</h4>
              <p>Inscripciones, categoría e historial en un solo lugar</p>
            </div>

            <div className="fila">
              <h3>Calendarios</h3>
              <h4>Todo el año organizado</h4>
              <p>Publicá las fechas para que todos los pilotos puedan consultarlas</p>
            </div>
          </div>
        </section>
        </FranjaFija>

        <FranjaFija izq="#06192A" der="#06192A">
        <section className="cta-intermedio">
          <h2>
            Sumá tu asociación <span className="texto-rojo-h2">a Mundo Piloto</span>
          </h2>
          <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" className="btn-whatsapp">
            <img src="/img/promo/whatsapp-icon.svg" alt="WhatsApp logo" className="icono-whatsapp" />
            Solicitar información por WhatsApp
          </a>
        </section>
        </FranjaFija>

        <FranjaFija izq={BORDES.casoReal[0]} der={BORDES.casoReal[1]}>
        <section className="datos-reales">
          <ul>
            <li>
              <span className="numero">+500</span> <span className="etiqueta">Pilotos registrados</span>
            </li>
            <li>
              <span className="numero">+9</span> <span className="etiqueta">Categorías administradas</span>
            </li>
            <li>
              <span className="numero">100%</span> <span className="etiqueta">Online</span>
            </li>
          </ul>
        </section>
        </FranjaFija>

        <FranjaFija izq="#EFEFEF">
          <PreguntasFrecuentes />
        </FranjaFija>

        <FranjaFija izq="#05192A" der="#05192A">
        <section className="contacto">
          <div className="contacto-contenido">
            <span className="barra-roja"></span>
            <h2>
              Llevá tu asociación <br />
              <span className="texto-rojo-h2">al siguiente nivel</span>
            </h2>
            <p>Escribinos y te mostramos cómo funciona para tu disciplina</p>
            <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" className="btn-whatsapp">
              <img src="/img/promo/whatsapp-icon.svg" alt="WhatsApp logo" className="icono-whatsapp" />
              Solicitar información por WhatsApp
            </a>
          </div>
        </section>
        </FranjaFija>
      </main>
      <BotonWhatsappFlotante />
    </div>
    <CustomFooter />
    </>
  );
};
